import React from 'react';
import ReactDOM from 'react-dom';
import MyAccount from '../pages/MyAccount';
import "../../less/app.less";
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from '../redux/store';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import ChangePassword from '../pages/ChangePassword';
import AdminLogin from '../admin/admin-pages/AdminLogin';
import AdminPanel from '../admin/admin-pages/AdminPanel';
import Dashboard from '../admin/admin-components/Dashboard';
import ManageUsers from '../admin/admin-pages/ManageUsers';
import Transactions from '../admin/admin-pages/Transactions';
import ActivityDetails from '../admin/admin-pages/ActivityDetails';
import PasswordLost from '../pages/PasswordLost';
import Cgu from '../pages/Cgu';
import Partners from '../pages/Partners';
import About from '../pages/About';
import Home from '../pages/Home';
import HomeContent from './HomeContent';
import { Navigate } from "react-router-dom";
import Welcome from '../pages/Welcome';
import EventMap from '../pages/EventMap';
import Media from '../pages/Media';
import Events from '../pages/Events';
import MyEvents from './account/MyEvents';
import TicketOrderResult from './TicketOrderResult';
import MyTickets from './account/MyTickets';
import AccountSetting from './account/AccountSetting';
import MyPayments from './account/MyPayments';
import MyOrganization from './account/MyOrganization';
import AdminEvents from '../admin/admin-pages/AdminEvents';
import AdminOrganizations from '../admin/admin-pages/AdminOrganizations';
import AdminMoments from '../admin/admin-pages/AdminMoments';
import AdminTickets from '../admin/admin-pages/AdminTickets';
import ScanTicket from '../admin/admin-pages/ScanTicket';
import ScanTicketFromAdmin from '../admin/admin-pages/ScanTicketFromAdmin';
import EventPage from '../pages/EventPage';
import TicketsPage from '../pages/TicketsPage';
import Vote from '../pages/Vote';
import ContestManagement from '../admin/admin-pages/ContestManagement';
import ContestSummary from '../admin/admin-pages/ContestSummary';
import ContestViewLink from './ContestViewLink';
import VoteResponse from '../pages/VoteResponse';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function App() {
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#694D36',
        colorLink: '#545454',
        borderRadius: "8px"
      }
    },
    children: /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsxs(Routes, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: "*",
          element: /*#__PURE__*/_jsx(Navigate, {
            to: "/home",
            replace: true
          })
        }), /*#__PURE__*/_jsxs(Route, {
          path: "home",
          element: /*#__PURE__*/_jsx(Home, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/home",
            element: /*#__PURE__*/_jsx(HomeContent, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "/home/welcome",
            element: /*#__PURE__*/_jsx(Welcome, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "map",
            element: /*#__PURE__*/_jsx(EventMap, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "vote",
            element: /*#__PURE__*/_jsx(Vote, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "voteresponse/:orderid",
            element: /*#__PURE__*/_jsx(VoteResponse, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "vote/:contest_id",
            element: /*#__PURE__*/_jsx(ContestViewLink, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "myorder/:orderid/:detail",
            element: /*#__PURE__*/_jsx(TicketsPage, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "medias",
            element: /*#__PURE__*/_jsx(Media, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "events",
            element: /*#__PURE__*/_jsx(Events, {})
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            path: "order/:orderid",
            element: /*#__PURE__*/_jsx(TicketOrderResult, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "event/:eventId",
            element: /*#__PURE__*/_jsx(EventPage, {})
          }), /*#__PURE__*/_jsxs(Route, {
            path: "compte",
            element: /*#__PURE__*/_jsx(MyAccount, {}),
            children: [/*#__PURE__*/_jsx(Route, {
              path: "/home/compte",
              element: /*#__PURE__*/_jsx(MyEvents, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/m-events",
              element: /*#__PURE__*/_jsx(MyEvents, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/m-events/:orderid",
              element: /*#__PURE__*/_jsx(MyEvents, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/m-tickets",
              element: /*#__PURE__*/_jsx(MyTickets, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/m-payments",
              element: /*#__PURE__*/_jsx(MyPayments, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/m-organization",
              element: /*#__PURE__*/_jsx(MyOrganization, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "/home/compte/profil",
              element: /*#__PURE__*/_jsx(AccountSetting, {})
            }), /*#__PURE__*/_jsx(Route, {
              path: "changesecret",
              element: /*#__PURE__*/_jsx(ChangePassword, {})
            })]
          }), /*#__PURE__*/_jsx(Route, {
            path: "password-lost/:mobile",
            element: /*#__PURE__*/_jsx(PasswordLost, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "cgu",
            element: /*#__PURE__*/_jsx(Cgu, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "about",
            element: /*#__PURE__*/_jsx(About, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "partenaires",
            element: /*#__PURE__*/_jsx(Partners, {})
          })]
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/az",
          element: /*#__PURE__*/_jsx(AdminLogin, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/az/auth",
          element: /*#__PURE__*/_jsx(AdminLogin, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "az/scanticket/:tid",
          element: /*#__PURE__*/_jsx(ScanTicket, {})
        }), /*#__PURE__*/_jsxs(Route, {
          path: "az/panel",
          element: /*#__PURE__*/_jsx(AdminPanel, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/az/panel",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dashboard",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-events",
            element: /*#__PURE__*/_jsx(AdminEvents, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-organizations",
            element: /*#__PURE__*/_jsx(AdminOrganizations, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "admin-flash-ticket",
            element: /*#__PURE__*/_jsx(ScanTicketFromAdmin, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-users",
            element: /*#__PURE__*/_jsx(ManageUsers, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-votes",
            element: /*#__PURE__*/_jsx(ContestManagement, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-votes/:id",
            element: /*#__PURE__*/_jsx(ContestSummary, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "manage-moments",
            element: /*#__PURE__*/_jsx(AdminMoments, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "tickets",
            element: /*#__PURE__*/_jsx(AdminTickets, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "transactions",
            element: /*#__PURE__*/_jsx(Transactions, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "activity-details",
            element: /*#__PURE__*/_jsx(ActivityDetails, {})
          })]
        })]
      })
    })
  });
}
export default App;
if (document.getElementById('app')) {
  ReactDOM.render(/*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {})
  }), document.getElementById('app'));
}